<template>
  <div class="col-12  mt-4">

    <h4 class="stage-results__subtitle">{{session.stage.description}}: <span class="nowrap">{{toLocaleDate(session.day)}}</span></h4>

    <div class="row"  v-for="row in rowStimuli">
      <div class="col-12 stage-results-wrapper"  v-if="row.stimuli">
        <p class="stage-results__subtitle" v-if="row.phaseType">
          {{row.phaseType | phaseNameByTypeId}}.
          <span>{{'protocol.check-list' | trans}} "{{row.taskType.title}}"</span>
        </p>
        <table class="stage-results-table table table-sm"
               v-if="!isMobile">
          <thead class="thead-light"  v-if="row.stimuli.length">
          <tr>
            <th></th>
            <th class="narrow-width text-center"
                v-for="(item, index) in row.answers" :key="'count' + index">
              {{item.title}}
            </th>
            <th class="narrow-width text-center"
                v-for="(item, index) in row.answers" :key="'persent' + index">
              {{item.title}}, %
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="stimulus in row.stimuli">
            <td>
              <span>{{stimulus.description}}</span>
            </td>
            <td class="text-center"
                v-for="item in stimulus.answers">
              <span>{{item.count ? item.count : trans('protocol.task_types.answers.no_data')}}</span>
            </td>
            <td class="text-center"
                v-for="item in stimulus.answers">
              <span>{{item.percent ? item.percent : trans('protocol.task_types.answers.no_data')}}</span>
            </td>
          </tr>
          <tr colspan="3" v-if="!row.stimuli.length" class="text-center">
            <h5>{{'bids.no_data' | trans }}</h5>
          </tr>
          </tbody>
        </table>

        <div class="mobile-table" v-else>
          <div class="mobile-table__body" v-if="row.stimuli.length">

            <div :key="index"
                 class="mobile-table__row"
                 v-for="(stimulus, index) in row.stimuli">
              <div class="mobile-table__head">
                {{stimulus.description}}
              </div>

              <div class="description">
                <p v-for="answer in stimulus.answers">
                  {{answerTitle(answer.answer, row)}}: {{answer.count ? answer.count :
                  trans('protocol.task_types.answers.no_data')}}</p>
                <p v-for="answer in stimulus.answers">
                  {{answerTitle(answer.answer, row)}},%: {{answer.percent ?
                  (answer.percent + '%') :
                  trans('protocol.task_types.answers.no_data')}}</p>
              </div>
            </div>
          </div>
          <h5 class="text-center" v-if="!row.stimuli.length">{{'bids.no_data' | trans }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment';
  import lang from '../../../lang/translator';
  import {mapGetters} from 'vuex';
  import filter from 'lodash/filter';

  export default {

    props: [
      'session',
      'rowStimuli'
    ],
    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
    },
    methods:{
      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },
      trans: function (key) {
        return lang.get(key);
      },
      answerTitle: function (answer, last) {
        let title = filter(last.answers, item => {
          return item.id == answer
        });

        return title.length ? title[0]['title'] : '';
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/modules/dashboardParent/components/LastSessionResults.vue